/* global ViewController, WebView, Handlebars */
var dinvoiceController = new ViewController({
    directory : "views/public",
    name: "dinvoicePublic",
    container: "main",
    route: "invoice-download"
}) ;

dinvoiceController.prepareDataOnEnter = function(token, callback){
    var path = "";
    var indexSlash = token.indexOf("/") ;
    if(indexSlash!==-1){
        path = token.substring(indexSlash) ;
        token = token.substring(0, indexSlash) ;
    }
    var data = {
        token: token,
        path: path
    } ;
    this.api.public.getDInvoiceInfos(token, function(err, result){
        if(err){
            if(err === "EXPIRED"){
                return callback(null, { expired: true }) ;
            }
            if(err === "NOT_FOUND"){
                return callback(null, { notfound: true }) ;
            }
            return callback(err) ;
        }
        data.result = result ;
        if(result.edition && result.edition.type && result.edition.type.download_title){
            let dinvoiceTitleSettings = result.edition.type.download_title ;
            try {
                Handlebars.compile(dinvoiceTitleSettings)({}) ;
            } catch (err) {          
                this.view.error(WebView.tr("dinvoice.downloadTitleWrongSyntax")) ;
                return callback(null, {msg:""}) ;
            }
            var templateTitle = Handlebars.compile(dinvoiceTitleSettings) ;
            result.name = templateTitle(result) ;
        }
        data.hasCustomBg = true ;
        callback(null, data) ;
    }.bind(this)) ;
};

dinvoiceController.onDownload = function(ev){
    this.view.longTask(function(done){
        this.api.public.downloadDInvoice(this.data.token, done) ;
    }.bind(this)) ;
} ;

dinvoiceController.onDownloadAttach = function(ev){
    let attach = ev.data.data ;
    this.view.longTask(function(done){
        this.api.public.downloadDInvoiceAttach(this.data.token, attach.id, done) ;
    }.bind(this)) ;
} ;


module.exports = dinvoiceController ;